import {
  KauflandCarrier,
  KauflandExternalCarrier,
  KauflandExternalShippingGroup,
  KauflandTransportMapping,
} from '../apiTypes';

export const mockKauflandExternalShippingGroups: KauflandExternalShippingGroup[] = [
  {
    currency: 'CZK',
    shippingGroupId: 1,
    storefront: 'CZ',
    name: 'SHIPPING GROUP 1',
    type: 'normal',
    isDefault: false,
    regions: [],
  },
  {
    currency: 'PLN',
    shippingGroupId: 2,
    storefront: 'CZ',
    name: 'SHIPPING GROUP 2',
    type: 'normal',
    isDefault: true,
    regions: [],
  },
  {
    currency: 'CZK',
    shippingGroupId: 3,
    storefront: 'CZ',
    name: 'SHIPPING GROUP 3',
    type: 'normal',
    isDefault: true,
    regions: [],
  },
];

export const mockKauflandExternalCarriers: KauflandExternalCarrier[] = [{
  name: 'DPD',
  isHauler: false,
},
{
  name: 'PPL',
  isHauler: false,
},
{
  name: 'GLS',
  isHauler: false,
},
{
  name: 'UPS',
  isHauler: false,
}];

export const mockKauflandTransportMappings: KauflandTransportMapping[] = [
  {
    partnerCode: '0001',
    shippingGroupId: '1',
    eshopCarrierId: 1,
  },
  {
    partnerCode: '0001',
    shippingGroupId: '2',
    eshopCarrierId: 2,
  },
];

export const mockKauflandCarrier: KauflandCarrier = {
  eshopCarrierId: 1,
  carrierCode: 'GLS',
};

export const mockKauflandCarriers: KauflandCarrier[] = [
  {
    eshopCarrierId: 1,
    carrierCode: 'GLS',
  },
  {
    eshopCarrierId: 2,
    carrierCode: 'DPD',
  },
  {
    eshopCarrierId: 3,
    carrierCode: 'UPS',
  },
];
